/* Cart popup being displayed when the user clicks on the cart icon */
import axios from 'axios';
// TODO: Free Gift add to windu

/**
 * Export default AjaxCart.
 */
export default () => {
  const product = theme.freeGift.id;
  const updateString = `updates[${product}]=1`;
  const removeString = `updates[${product}]=0`;

  function init() {
    if (theme.freeGift.enable === false) {
      return false;
    }

    setBusListeners();
  }

  function setBusListeners() {
    Karmoon.EventBus.listen(
      ['AjaxCart:updated', 'AddToCart:itemRemoved', 'AddToCart:itemAdded', 'Cart:itemAdded', 'Cart:updated'], (cartData) => {
      getCartJSON();
    });
  }

  function getCartJSON(callback, x, y) {
    axios
      .get(`/cart.js?no-cache}`)
      .then((response) => {
        freeGiftCheck(response.data);
      })
      .catch((error) => {
        window.console.error(error);
        return error;
      });
  }

  // Free Gift Check
  function freeGiftCheck(cart) {
    const freeGiftThreshold = theme.freeGift.threshold * 100;
    const cartItems = cart.items;
    let cartTotal = cart.total_price;
    cartItems.forEach(function(item) {
      if(item.id === product) {
        cartTotal = cartTotal - item.final_price;
        return;
      }
    })
    const valueUntilFree = freeGiftThreshold - cartTotal;
    if (valueUntilFree <= 0) {
      console.log('🎁 A gift has been added');
      addGift(cart);
    } else {
      removeGift(cart);
    }
  }

  function addGift(cartData) {
    var giftInBag = false;

    cartData.items.forEach((item) => {
      if (item.id === product) {
        giftInBag = true;
      }
    });

    if (giftInBag === false) {
      axios.post('/cart/update.js', updateString)
      .then((item) => {
        Karmoon.EventBus.emit('AddToCart:itemAdded', item);
      })
    }

  }

  function removeGift(cartData) {
    cartData.items.forEach((item) => {
      if (item.id == product) {
        axios.post('/cart/update.js', removeString)
          .then((item) => {
            Karmoon.EventBus.emit('AddToCart:itemAdded', item);
          })
      }
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
